var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.639 4.53c1.317-2.682 4.076-4.53 7.268-4.53 4.47 0 8.093 3.623 8.093 8.093 0 1.197-0.2603 2.335-0.7281 3.359-0.1221 0.2674-0.1459 0.5198-0.0917 0.7228l0.1422 0.5313c0.4551 1.701-1.101 3.257-2.802 2.802l-0.5313-0.1422c-0.1511-0.0404-0.3295-0.0375-0.5212 0.0169-0.5694 4.852-4.695 8.617-9.7 8.617-1.507 0-2.936-0.3418-4.213-0.9529-0.2527-0.121-0.5015-0.1456-0.7062-0.0908l-1.369 0.3661c-1.701 0.4551-3.257-1.101-2.802-2.802l0.3662-1.368c0.05477-0.2047 0.03022-0.4535-0.09076-0.7063-0.6112-1.276-0.953-2.706-0.953-4.213 0-5.013 3.776-9.143 8.639-9.703zm1.949-0.03053c4.828 0.4015 8.658 4.314 8.931 9.177 0.2931-0.0279 0.5976-9e-3 0.9025 0.0726l0.5313 0.1422c0.4563 0.1221 0.8739-0.2955 0.7518-0.7518l-0.1422-0.5313c-0.1754-0.6557-0.0611-1.31 0.1861-1.851 0.3701-0.8103 0.5767-1.712 0.5767-2.664 0-3.545-2.874-6.418-6.418-6.418-2.212 0-4.165 1.119-5.319 2.825zm-0.8205 1.64c-4.47 0-8.093 3.623-8.093 8.093 0 1.251 0.2834 2.434 0.7888 3.49 0.2628 0.5489 0.373 1.208 0.198 1.862l-0.3662 1.368c-0.1221 0.4563 0.2954 0.8739 0.7518 0.7518l1.369-0.3663c0.6538-0.1749 1.313-0.0647 1.862 0.1981 1.056 0.5054 2.238 0.7888 3.49 0.7888 4.47 0 8.093-3.623 8.093-8.093 0-4.47-3.623-8.093-8.093-8.093z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 14c0 0.5523-0.4477 1-1 1s-1-0.4477-1-1 0.4477-1 1-1 1 0.4477 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 14c0 0.5523-0.4477 1-1 1-0.5523 0-1-0.4477-1-1s0.4477-1 1-1c0.5523 0 1 0.4477 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 14c0 0.5523-0.4477 1-1 1s-1-0.4477-1-1 0.4477-1 1-1 1 0.4477 1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.49558b2a4e88cee39df26f15ecf62e7c.svg";
export { ForwardRef as ReactComponent };